import script from "./Table.vue?vue&type=script&lang=ts&setup=true&generic=ColId%20extends%20string%2C%20SortIdType%20extends%20string%2C%20ColData%2C%20RowId%20extends%20string%2C%20RowData"
export * from "./Table.vue?vue&type=script&lang=ts&setup=true&generic=ColId%20extends%20string%2C%20SortIdType%20extends%20string%2C%20ColData%2C%20RowId%20extends%20string%2C%20RowData"

const __exports__ = script;

export default __exports__